import { Abstract, Modify } from '../commons/commons.types';
import { DroneClearanceEnum, StrategicDrone } from './drone.types';
import { Pilot } from './pilot.types';

export enum ChipTypeEnum {
  HLD = 'HLD',
}

type Chip = [string, ChipTypeEnum];

export type Fleet = {
  id: number;
  code: string;
  site: string;
  name: string;
  organization: string;
  strategicClearance: DroneClearanceEnum;
  pilots: Pilot[];
  drones: StrategicDrone[];
  chips: Chip[];
} & Abstract;

export type NormalizedFleet = Modify<
  Fleet,
  {
    pilots: string[];
    drones: string[];
  }
>;
